export function SeaContent() {
  return (
    <p className="text-xs text-telekinesis-text-secondary">
      Hull designer coming soon.
    </p>
  );
}
